import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const ImageName = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  marginBottom: "24px",
  marginTop: "24px",
  marginRight: "8px",
}));

export const Image = styled("img")(({ theme }) => ({
  width: "100%",
  height: "100%",
}));
